import { DeviceThing } from '../../types/DeviceThing.types'
import { FormState } from '../../types/FormState.types'

type DeviceConfigShape = Pick<DeviceThing, 'system' | 'datasyncd' | 'connman' | 'gsm' | 'vend'>

export const deviceToFormState = (device: DeviceConfigShape): FormState => ({
    system: device.system,
    datasyncd: device.datasyncd,
    connman: device.connman,
    gsm: device.gsm,
    vend: device.vend,
})
